import React from "react";
import { useNavigate } from "react-router-dom";

// Compoents
import Layout from "@/components/layout";
import StaffCard from "@/components/staffCard";
import Title from "@/components/title";
// import { SearchingBar, EscapeRegExp } from "@/components/searchingBar";
import { enumerateDaysBetweenDates } from "@/lib/enumerateDaysBetweenDates";

// Fetch
import { approveStockOnHandList, getAllRefillList } from "@/fetch/fetchStock";

// Mui
import Grid from "@mui/material/Grid2";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
// import IconButton from "@mui/material/IconButton";
// import Tooltip from "@mui/material/Tooltip";

// Mui Icon
// import DownloadIcon from "@mui/icons-material/Download";

// Mui Styles
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { StyledPaper } from "@/styles/mui/globalStyles";
// import { TableListTheme } from "@/styles/mui/tableListTheme";

// Config
import { exportCSVFile } from "@/config/csvConfig";

// Moment
import { useCurrentAction } from "@/hooks/user";
import _ from "lodash";
import moment from "moment";
import "moment/locale/zh-hk";

const RefillRequestPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // State
  const [loading, setLoading] = React.useState(false);
  const [refillListData, setRefillListData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");

  const navigate = useNavigate();
  const fileReader = new FileReader();
  const start_date = moment().subtract(30, "days").format("YYYY-MM-DD");
  const end_date = moment().subtract(1, "days").format("YYYY-MM-DD");
  const days = enumerateDaysBetweenDates(start_date, end_date);
  let dayHeader = {};
  _.forEach(days, (day) => {
    dayHeader[day] = day;
  });
  const handleDownloadCsv = async () => {
    var headers = {
      invoice_id: "invoice_id".replace(/,/g, ""),
      stockonhand_refill_item_id: "stockonhand_refill_item_id",
      item_id: "item_id",
      users_id: "users_id",
      area: "area",
      shop: "shop",
      customer_code: "customer_code",
      promoter: "promoter",
      code: "code",
      gift_item: "gift_item",
      price: "price",
      ...dayHeader,
      soh: "soh",
      pharmagood: "pharmagood",
      request_total_qty: "request_total_qty",
      time_created: "time_created",
      last_stocktake: "last_stocktake",
      approve_total_qty: "approve_total_qty",
      si_number: "si_number",
    };

    if (!loading) {
      setLoading(true);

      exportCSVFile(
        headers,
        refillListData,
        `Refill Setting - ${moment().format("YYYY-MM-DD")}`,
      );
      setLoading(false);
    }
  };

  const fetchAll = async (isExport, isApprove) => {
    await getAllRefillList(isExport, isApprove).then((data) => {
      if (data && data.results) {
        let tempArr = [...data.data];
        for (let i = 0; i < tempArr.length; i++) {
          tempArr[i].time_created = moment(tempArr[i].time_created).format(
            "YYYY-MM-DD H:mm:ss",
          );
          tempArr[i].last_stocktake = tempArr[i].last_stocktake
            ? moment(tempArr[i].last_stocktake).format("YYYY-MM-DD")
            : "N/A";
        }
        setRefillListData(tempArr);
      }
    });
  };

  const handleOnChangeUpload = (e) => {
    e.preventDefault();

    const file = e.target.files[0];
    let invaildDatas = [];
    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target.result;

        const quoteChar = '"';
        const delimiter = ",";

        const regex = new RegExp(
          `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
          "gs",
        );

        const match = (line) =>
          [...line.matchAll(regex)]
            .map((m) => m[2]) // we only want the second capture group
            .slice(0, -1); // cut off blank match at the end

        var lines = text.split("\n");
        var result = [];

        // Read first row and display first column
        // var readVersion = lines[0].split(",");
        // var version = readVersion[0];

        var headers = match(lines.shift());
        // var headers = lines[1].split(",");
        // for (let i = 0; i < headers.length; i++) {
        //   headers[i] = headers[i].replace(`\r`, "");
        // }

        // Rows, skip 0
        for (var i = 0; i < lines.length; i++) {
          var obj = {};
          var currentline = match(lines[i]);

          // Columns
          for (var j = 0; j < headers.length; j++) {
            if (currentline[j] !== "" && currentline[j] !== undefined) {
              obj[headers[j]] = currentline[j];
            }
          }
          if (
            Number(obj.approve_total_qty) > 0 &&
            obj.si_number === undefined
          ) {
            invaildDatas.push({
              row: i + 2,
              reason: "沒有填寫si_number",
            });
          }
          result.push(obj);
        }
        // Output
        if (invaildDatas.length > 0) {
          let message = `上傳失敗\n原因:\n`;
          _.forEach(invaildDatas, (invaildData) => {
            message += `行${invaildData.row}: ${invaildData.reason}`;
          });
          setSnackMessage(message);
          setSnackSeverity("error");
          setSnackOpen(true);
        } else {
          await approveStockOnHandList(result).then((data) => {
            if (data.results) {
              setSnackSeverity("success");
              setSnackMessage(`上傳成功`);
            } else {
              setSnackSeverity("error");
              setSnackMessage(`上傳失敗`);
            }
            setSnackOpen(true);
            setTimeout(() => {
              setSnackOpen(false);
            }, 3000);
          });
        }
        fetchAll();
      };

      fileReader.readAsText(file);
    }
    e.target.value = null;
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="RefillRequestPage"
      selectedIndex={4}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`補貨請求`} history={() => navigate(-1)} />
      <Grid container spacing={2} sx={{ height: "80vh" }}>
        {actions?.download && (
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 6,
              lg: 3,
            }}
          >
            <StaffCard
              download={true}
              type={"refill"}
              disable={refillListData.length < 0 ? true : undefined}
              displayName={`申請請求 ${refillListData.length} 項`}
              onClickDownload={() => handleDownloadCsv()}
            />
          </Grid>
        )}
        {actions?.approve && (
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 6,
              lg: 3,
            }}
          >
            <StaffCard
              upload={true}
              type={"refill"}
              displayName={"完成審批"}
              onChangeUpload={(e) => handleOnChangeUpload(e)}
            />
          </Grid>
        )}
      </Grid>
    </Layout>
  );
};

export default RefillRequestPage;
